module.exports = __webpack_public_path__ + "images/compass-53ad24e4e9c623993396b6f5eb1aef1f.jpg";